import './Drawer.css';

export default function Drawer({
  isOpen,
  title = '',
  onClose,
  children,
  IconButton,
  width = '420px',
}) {
  if (!isOpen) return null;

  return (
    <div className='drawer-overlay' role='presentation' onClick={onClose}>
      <aside
        className='drawer-panel'
        role='dialog'
        aria-modal='true'
        style={{ width }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className='drawer-header'>
          <h3 className='drawer-title'>{title}</h3>
          {IconButton ? (
            <IconButton ariaLabel='cerrar' icon='close' size='sm' onClick={onClose} />
          ) : (
            <button
              type='button'
              className='drawer-close'
              aria-label='cerrar'
              onClick={onClose}
            >
              x
            </button>
          )}
        </div>
        <div className='drawer-body'>{children}</div>
      </aside>
    </div>
  );
}
